// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__CVy0o","disabled":"radio_disabled__LSCy7"};